import { EuiButtonIcon, EuiHeader, EuiHeaderLink, EuiHeaderSectionItem } from "@elastic/eui";
import React, { useContext } from "react";
import { useHistory, useLocation } from "react-router";

import { UserContext } from "../App";
import cannabisIcon from "../images/cannabis_icon.svg";
import horecaIcon from "../images/horeca_icon.svg";
import { ShopContext } from "../utils/Shop";
import { setTheme } from "../utils/Utils";
import { PriceShowSwitcher } from "./PriceShowSwitcher";
import { ShopSwitcher } from "./ShopSwitcher";

export default function Header(themeSwitcher, ...props) {
    const location = useLocation();
    const history = useHistory();

    // const { theme } = useContext(ThemeContext);

    console.log(UserContext.Consumer);
    // Ugly hook; as the context seems not working ok
    const theme = localStorage.getItem("darkMode") || false ? "dark" : "light";
    const { isUsingMultiScreen } = useContext(ShopContext);
    console.log("isUsingMultiScreen from Context", isUsingMultiScreen);

    return (
        <UserContext.Consumer>
            {(user) => (
                <EuiHeader className="header">
                    <EuiHeaderSectionItem border="none" size="large">
                        <EuiHeaderLink
                            onClick={() => history.push("/products/cannabis")}
                            isActive={location.pathname.startsWith("/products")}
                        >
                            Producten
                        </EuiHeaderLink>
                        <EuiHeaderLink
                            onClick={() => history.push("/categories")}
                            isActive={location.pathname.startsWith("/categories")}
                        >
                            Categorieën
                        </EuiHeaderLink>
                        {isUsingMultiScreen && (
                            <EuiHeaderLink
                                onClick={() => history.push("/screens")}
                                isActive={location.pathname.startsWith("/screens")}
                            >
                                Schermen
                            </EuiHeaderLink>
                        )}
                        <EuiHeaderLink
                            isActive={location.pathname.startsWith("/orders")}
                            onClick={() => history.push("/orders")}
                        >
                            Orders
                        </EuiHeaderLink>
                        {user && user?.profile?.is_superuser && (
                            <EuiHeaderLink
                                isActive={location.pathname.startsWith("/admin")}
                                onClick={() => history.push("/admin")}
                            >
                                Admin Page
                            </EuiHeaderLink>
                        )}
                    </EuiHeaderSectionItem>
                    <EuiHeaderSectionItem color="primary">
                        {/*Temp !user.profile.email.endsWith("@prijslijst.info") workaround until the employee permissions are fixed*/}
                        {user.isLoggedIn && <ShopSwitcher />}
                        {user.isLoggedIn && <PriceShowSwitcher />}
                        {user.isLoggedIn && !user.profile.email.endsWith("@prijslijst.info") && (
                            <>
                                <EuiHeaderLink onClick={() => history.push("/manage/soorten")}>
                                    <EuiButtonIcon aria-label="manageKinds" iconSize={"xl"} iconType={cannabisIcon} />
                                </EuiHeaderLink>
                                <EuiHeaderLink onClick={() => history.push("/manage/horeca")}>
                                    <EuiButtonIcon aria-label="manageHoreca" iconSize={"xl"} iconType={horecaIcon} />
                                </EuiHeaderLink>
                                {user && user?.profile?.is_superuser && (
                                    <EuiHeaderLink onClick={() => history.push("/manage/quick-editor")} tooltip={"loe"}>
                                        <EuiButtonIcon aria-label="quickEditor" iconType="grid" />
                                    </EuiHeaderLink>
                                )}
                            </>
                        )}
                        <EuiHeaderLink onClick={() => setTheme(theme === "light" ? "dark" : "light")}>
                            <EuiButtonIcon
                                aria-label="darkThemeToggle"
                                iconType={theme === "light" ? "moon" : "cloudSunny"}
                            />
                        </EuiHeaderLink>
                        {!user.isLoggedIn && (
                            <EuiHeaderLink
                                onClick={() => history.push("/login")}
                                isActive={location.pathname.startsWith("/login")}
                            >
                                <EuiButtonIcon iconType="user" />
                            </EuiHeaderLink>
                        )}
                        {user.isLoggedIn && (
                            <EuiHeaderLink
                                onClick={() => history.push("/logout")}
                                isActive={location.pathname.startsWith("/logout")}
                            >
                                <EuiButtonIcon iconType="exit" />
                            </EuiHeaderLink>
                        )}
                    </EuiHeaderSectionItem>
                </EuiHeader>
            )}
        </UserContext.Consumer>
    );
}
